import Chris from "./Img/Chris.jpg";
import Can from "./Img/CrushedCan.jpg";
import Distortion from "./Img/Holyjpg.jpg";
import Emimen from "./Img/Eminem.jpg";
import Nanny from "./Img/NannyBoredApe.jpg";
import Obsidian from "./Img/ObsidianBoredApe.jpg";
import World from "./Img/Modelpose.png";

const images = [
  { id: 1, image: Chris },
  { id: 2, image: Can },
  { id: 3, image: Emimen },
  { id: 4, image: Nanny },
  { id: 5, image: Distortion },
  { id: 6, image: World },
  { id: 7, image: Obsidian },
];
export default images;
